import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NestCamWiredStandIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nest_cam_wired_stand"}/>
}
